class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.updateQuantityArg = {}

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      if (event.target.closest('.set-item')) {
        let keys = []
        let wcSetId = event.target.closest('.set-item').dataset.wcSetId

        cartItems.querySelectorAll(`.cart-item[data-wc-parent-set-id="${wcSetId}"]`).forEach(item => {
          keys.push(item.dataset.key)
        })

        this.updateQuantityArgs = {
          quantity: 0,
          name: '',
          key: keys,
          set: true
        }
      } else {
        this.updateQuantityArgs = {
          line: this.dataset.index,
          quantity: 0,
          name: '',
          key: this.dataset.key
        }
      }

      cartItems.updateQuantity(this.updateQuantityArgs)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.giftTypes = ['gift','sample'];
    this.giftTypes.forEach(type => this.wcCheckGiftEligability(type));
    this.wcPreventEnterKeySubmit();
  }

  onChange(event) {

    let updateQuantityArgs = {
      line: event.target.dataset.index,
      quantity: event.target.value,
      name: document.activeElement.getAttribute('name'),
      key: event.target.dataset.key
    }

    this.updateQuantity(updateQuantityArgs);
    this.giftTypes.forEach(type => this.wcCheckGiftEligability(type));

  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(args) {

    this.enableLoading(args.line);

    let line = args.line,
    quantity = args.quantity,
    name = args.name,
    key = args.key,
    set = args.set,
    body = '',
    removeItem = {},
    change_route = routes.cart_change_url,
    render_sections = this.getSectionsToRender().map((section) => section.section),
    precart_check = document.querySelector('cart-drawer').dataset.wcAddedItemId;

    if(!!key){  
      change_route = routes.cart_update_url;

      if (!!set) {
        key.forEach(key => {
          removeItem = { ...removeItem, [key]: 0 }
        })
      } else {
        //console.log('cart_update_url')
        removeItem = { ...removeItem, [key]: 0 }
      }

      body = JSON.stringify({
        updates: removeItem,
        sections: render_sections,
        sections_url: window.location.pathname
      });
    } else {
      //console.log('cart_change_url')
      body = JSON.stringify({
        line,
        quantity,
        sections: render_sections,
        sections_url: window.location.pathname
      });
    }

    if (precart_check != ''){
      document.querySelector('.wc-cart-drawer__view-cart').click()
    }

    fetch(`${change_route}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        
        let parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }

  wcCheckGiftEligability(type) {

    this.wrapperClass = type == 'sample' ? ".wc-sample__container" : ".wc-gwtp__container";
    let giftProgressBar = document.querySelector(this.wrapperClass + ' progress#wc-gwp-prograss-bar');

    if(giftProgressBar){

      let cartGiftTotal = parseFloat(this.dataset.wcCartTotal);
      let nextGiftThreshold = parseFloat(giftProgressBar.dataset.nextthreshold);
      let currentGiftThreshold = parseFloat(giftProgressBar.dataset.currentthreshold);
      let nextGiftThresholdCheck = parseFloat(nextGiftThreshold) * 100;
      let allowedGifts = type == 'sample' ? parseFloat(giftProgressBar.dataset.totalsamples) : parseFloat(giftProgressBar.dataset.totalgwp);

      this.giftItemWrapper = document.querySelector(this.wrapperClass);
      this.giftItemList = this.giftItemWrapper.querySelector('ul');
      this.giftItems = this.giftItemWrapper.querySelectorAll('.wc-gwp-gift--qualifies');
      this.giftItemsEligible = this.giftItemWrapper.querySelectorAll('.gift-' + nextGiftThreshold + ':not(.wc-gwp-gift--removed)');
      this.giftItemsNotEligible = this.giftItemWrapper.querySelectorAll('.wc-gwp-gift.wc-gwp-gift--qualifies:not(.gift-' + nextGiftThreshold +')');
      this.giftItemsCurrent = this.giftItemWrapper.querySelector(' .wc-gwp-gift--current');
      this.giftQualifiesHeader = this.giftItemWrapper.querySelector('.wc-prograss-bar-container__message--qualifies');
      this.giftAddedHeader = this.giftItemWrapper.querySelector('.wc-prograss-bar-container__message--added');
      this.giftRemoveButtons = this.querySelectorAll('cart-remove-button[data-wc-type="'+ type +'"]');
      this.giftTrueItems = document.querySelectorAll('.drawer__cart-items-wrapper .wc-cart-item--gift-item');

      if (this.giftItemList.getElementsByTagName('li').length === 0){
        this.giftItemWrapper.classList.add('hidden');
      }

      this.giftTrueItems.forEach(giftTrueItem => {
        giftTrueItem.querySelector('quantity-input.quantity')?.remove();
      });

      if (this.giftItemsCurrent){

        if(allowedGifts > this.giftRemoveButtons.length){
          //pick more
        }else{
          this.giftQualifiesHeader.classList.add('hidden');
          this.giftAddedHeader.classList.remove('hidden');
          this.giftItemsCurrent.classList.remove('hidden');

          this.giftItems.forEach(giftItem => {

            let itemGiftThreshold = parseFloat(giftItem.querySelector('gwtp-gift-item.cart-item').dataset.threshold);
            let currentItemGiftThreshold = parseFloat(this.giftItemsCurrent.querySelector('gwtp-gift-item.cart-item').dataset.threshold);

            if(itemGiftThreshold >= nextGiftThreshold && currentItemGiftThreshold < nextGiftThreshold){

              let itemToRemove = this.giftItemsCurrent.querySelector('.wc-fake-quantity .quantity__button label').getAttribute('for');
              let itemToRemoveButton = document.getElementById(itemToRemove).closest('cart-remove-button');

              let updateQuantityArgs = {
                line: itemToRemoveButton.dataset.index,
                quantity: 0,
                name: itemToRemoveButton.getAttribute('name'),
                key: itemToRemoveButton.dataset.key
              }
              this.updateQuantity(updateQuantityArgs);

            }else{
              giftItem.classList.add('hidden');
              giftItem.querySelector('.product-form')?.remove();
            }
            
          });

          /*
          this.giftItemsEligible.forEach(giftItem => {
              //giftItem.querySelector('.product-form')?.remove();
          });
          */

        }

      }else{
        this.giftQualifiesHeader.classList.remove('hidden');
        this.giftAddedHeader.classList.add('hidden');
      }

      this.giftItemsEligible.forEach(giftItem => {
        giftItem.classList.remove('hidden');
      });


      this.giftItemsNotEligible.forEach(giftItem => {

        let itemGiftThreshold = parseFloat(giftItem.querySelector('gwtp-gift-item.cart-item').dataset.threshold);

        if(itemGiftThreshold > nextGiftThreshold){
          giftItem.querySelector('.product-form')?.remove();
          giftItem.querySelector('.pseudo-product-form')?.classList.remove('hidden');
        }

        if(cartGiftTotal > currentGiftThreshold){
          if((itemGiftThreshold < nextGiftThreshold) && (itemGiftThreshold > currentGiftThreshold)){
            giftItem.classList.remove('hidden');
          }else{
            if(itemGiftThreshold < currentGiftThreshold){
              giftItem.classList.add('hidden');
              giftItem.querySelector('.product-form')?.remove();
            }
          }
        }

        if((cartGiftTotal >= nextGiftThresholdCheck) && (itemGiftThreshold < nextGiftThreshold)){
            giftItem.classList.add('hidden');
            giftItem.querySelector('.product-form')?.remove();
        }

      });

      this.giftRemoveButtons.forEach(removeButton => {
        const giftThreshold = parseFloat(removeButton.dataset.wcThreshold) * 100;

        let updateQuantityArgs = {
          line: removeButton.dataset.index,
          quantity: 0,
          name: removeButton.getAttribute('name'),
          key: removeButton.dataset.key
        }

        if (cartGiftTotal < giftThreshold) {
          this.updateQuantity(updateQuantityArgs);
        }
        if (giftThreshold > nextGiftThresholdCheck){
          this.updateQuantity(updateQuantityArgs);
        }
      });

      if(this.giftRemoveButtons.length > allowedGifts){
        this.giftRemoveButtons.forEach(removeButton => {
          let updateQuantityArgs = {
            line: removeButton.dataset.index,
            quantity: 0,
            name: removeButton.getAttribute('name'),
            key: removeButton.dataset.key
          }
          this.updateQuantity(updateQuantityArgs);
        });
      }

    }

  }

  wcPreventEnterKeySubmit() {
    const quantityInputs = this.querySelectorAll('.quantity__input');
    quantityInputs.forEach(input => {
      input.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') event.preventDefault();
      });
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
